import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const OsAndroidIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_304"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_304)">
        <path
          d="M1 11.2991C1.09545 10.1643 1.44291 9.1196 2.04236 8.16505C2.64182 7.2105 3.43982 6.45217 4.43636 5.89005L3.25909 3.85369C3.19545 3.75823 3.17955 3.65747 3.21136 3.55141C3.24318 3.44535 3.31212 3.36581 3.41818 3.31278C3.50303 3.25975 3.59848 3.24914 3.70455 3.28096C3.81061 3.31278 3.89545 3.37641 3.95909 3.47187L5.13636 5.50823C6.04848 5.12641 7.00303 4.9355 8 4.9355C8.99697 4.9355 9.95152 5.12641 10.8636 5.50823L12.0409 3.47187C12.1045 3.37641 12.1894 3.31278 12.2955 3.28096C12.4015 3.24914 12.497 3.25975 12.5818 3.31278C12.6879 3.36581 12.7568 3.44535 12.7886 3.55141C12.8205 3.65747 12.8045 3.75823 12.7409 3.85369L11.5636 5.89005C12.5606 6.45217 13.3586 7.2105 13.9576 8.16505C14.5567 9.1196 14.9041 10.1643 15 11.2991H1ZM4.81818 9.54914C5.04091 9.54914 5.22927 9.47214 5.38327 9.31814C5.53727 9.16414 5.61406 8.97599 5.61364 8.75369C5.61321 8.53138 5.53621 8.34302 5.38264 8.1886C5.22906 8.03417 5.04091 7.95738 4.81818 7.95823C4.59545 7.95908 4.40709 8.03608 4.25309 8.18923C4.09909 8.34238 4.0223 8.53054 4.02273 8.75369C4.02315 8.97684 4.10015 9.1652 4.25373 9.31878C4.4073 9.47235 4.59545 9.54914 4.81818 9.54914ZM11.1818 9.54914C11.4045 9.54914 11.5929 9.47214 11.7469 9.31814C11.9009 9.16414 11.9777 8.97599 11.9773 8.75369C11.9768 8.53138 11.8998 8.34302 11.7463 8.1886C11.5927 8.03417 11.4045 7.95738 11.1818 7.95823C10.9591 7.95908 10.7707 8.03608 10.6167 8.18923C10.4627 8.34238 10.3859 8.53054 10.3864 8.75369C10.3868 8.97684 10.4638 9.1652 10.6174 9.31878C10.7709 9.47235 10.9591 9.54914 11.1818 9.54914Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

OsAndroidIcon.displayName = "OsAndroidIcon";
